export interface VictoryStats {
  playtimeSec: number;
  slimeMassKg: number;
  mutationsUnlocked: number;
  bossDefeated: string;
}

export interface VictoryModalOptions {
  containerElement?: HTMLElement | null;
}

export class VictoryModal {
  private container: HTMLElement | null = null;
  private visible: boolean = false;

  constructor(options: VictoryModalOptions = {}) {
    if (options.containerElement !== undefined) {
      this.container = options.containerElement;
    } else if (typeof document !== 'undefined') {
      this.container = document.getElementById('modal-victory-overlay');
    }

    if (this.container) {
      this.container.style.display = 'none';
    }
  }

  public isVisible(): boolean {
    return this.visible;
  }

  public show(stats: VictoryStats): void {
    this.visible = true;
    if (!this.container) return;

    const mins = Math.floor(stats.playtimeSec / 60);
    const secs = Math.floor(stats.playtimeSec % 60);
    const formattedTime = `${mins}m ${secs}s`;

    this.container.style.display = 'flex';
    this.container.innerHTML = `
      <div class="victory-card">
        <h1 class="victory-headline">👑 VICTORY ACHIEVED! 👑</h1>
        <p class="victory-subhead">You have vanquished the ancient titan and mastered the Primordial Realm!</p>
        
        <div class="victory-stats-grid">
          <div class="stat-box">
            <div class="stat-label">⏱️ Playtime</div>
            <div class="stat-value">${formattedTime}</div>
          </div>
          <div class="stat-box">
            <div class="stat-label">⚖️ Final Slime Mass</div>
            <div class="stat-value">${stats.slimeMassKg.toFixed(1)} kg</div>
          </div>
          <div class="stat-box">
            <div class="stat-label">🧬 Mutations Unlocked</div>
            <div class="stat-value">${stats.mutationsUnlocked}</div>
          </div>
          <div class="stat-box">
            <div class="stat-label">💀 Boss Defeated</div>
            <div class="stat-value">${stats.bossDefeated}</div>
          </div>
        </div>

        <button id="btn-victory-continue" class="victory-btn">✨ Continue in Sandbox Mode ✨</button>
      </div>
    `;

    const btn = this.container.querySelector('#btn-victory-continue');
    btn?.addEventListener('click', () => {
      this.hide();
    });
  }

  public hide(): void {
    this.visible = false;
    if (this.container) {
      this.container.style.display = 'none';
    }
  }
}
